export default class buildTaskModalCtr {
  constructor(
    $scope,
    $uibModalInstance,
    selectedRows,
    logger,
    declareType,
    allApplyPeriod,
    httpRequest
  ) {
    $scope.submit = {
      sign: '1',
    }
    $scope.declareType = declareType.filter((item) => {
      return item.enumCode != 2
    })
    $scope.selectedRows = selectedRows
    $scope.allApplyPeriod = allApplyPeriod
    // 所有纳税人类型
    $scope.taxTypeList = []
    $scope.taxTypeListId = []
    for (let i = 0; i < $scope.selectedRows.length; i++) {
      $scope.taxTypeList.push($scope.selectedRows[i].taxplayerType)
      $scope.taxTypeListId.push($scope.selectedRows[i].taxId)
    }
    $scope.submit.taxId = $scope.taxTypeListId.map(String)
    $scope.cancel = function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
    $scope.ok = function ok() {
      if (!$scope.checkInfo()) {
        return
      }
      if (!$scope.checkTypeCycle($scope.submit)) {
        return
      }
      submit()
    }
    function submit() {
      httpRequest.post_syncInvoice($scope.submit).then((res) => {
        if (res.data.success) {
          logger.logSuccess('生成申报任务')
          $uibModalInstance.close()
        }
      })
    }
    // 校验不为空
    $scope.checkInfo = function () {
      if (!$scope.submit.sign) {
        logger.logError('申报税种类不允许为空')
        return false
      }
      if (!$scope.submit.applyPeriod) {
        logger.logError('纳税申报期不允许为空')
        return false
      }
      return true
    }
    // 校验是否均是一般纳税人或小规模纳税人
    $scope.checkTypeCycle = function (data) {
      switch (true) {
        case data.sign === '1':
          $scope.isBoolean = sameTaxpayerType($scope.selectedRows)
          break
        default:
          $scope.isBoolean = defaultSubmit()
      }
      return $scope.isBoolean
    }
    function sameTaxpayerType(selectedRows) {
      if (!isAllEqual($scope.taxTypeList)) {
        logger.logError(
          '所选纳税人既有一般纳税人又有小规模纳税人，请筛选纳税人类型重新选择。'
        )
        return false
      } else {
        // 所选纳税人均是一般纳税人或小规模纳税人
        $scope.taxplayerType = $scope.taxTypeList[0]
        let flag = $scope.submit.applyPeriod.indexOf('Q')
        if ($scope.taxplayerType == '小规模纳税人' && flag == -1) {
          logger.logError('所选纳税人、申报税种类的申报周期不同，请重新选择。')
          return false
        } else if ($scope.taxplayerType == '一般纳税人' && flag != -1) {
          logger.logError('所选纳税人、申报税种类的申报周期不同，请重新选择。')
          return false
        }
        $scope.taxplayerType == '小规模纳税人'
          ? ($scope.submit.sign = '4')
          : ($scope.submit.sign = '1')
      }
      return true
    }
    function defaultSubmit() {
      //判断申报期是否相同
      if (!$scope.sameReportingPeriod()) {
        return false
      }
      submit()
      return false
    }
    $scope.sameReportingPeriod = function () {
      httpRequest
        .post_queryConfigtaxId(JSON.stringify($scope.taxTypeListId))
        .then((res) => {
          $scope.list = res.data.value.filter((item) => {
            return item.declareType == 3
          })
          let reportingPeriod = []
          angular.forEach($scope.list, (item, index) => {
            reportingPeriod.push(item.reportingPeriod)
          })
          let applyFlag = $scope.submit.applyPeriod.indexOf('Q')
          // 季度=2 月=1
          reportingPeriod.unshift(String(applyFlag == -1 ? 1 : 2))
          console.log(reportingPeriod)
          if (!isAllEqual(reportingPeriod)) {
            logger.logError(
              '所选纳税人、申报税种类的申报周期不同，请重新选择。'
            )
            return false
          } else {
            submit()
          }
        })
    }
    // 验证值是否相同
    function isAllEqual(array) {
      if (array.length > 0) {
        return !array.some((value, index) => {
          return value !== array[0]
        })
      } else {
        return true
      }
    }
  }
}
buildTaskModalCtr.$inject = [
  '$scope',
  '$uibModalInstance',
  'selectedRows',
  'logger',
  'declareType',
  'allApplyPeriod',
  'httpRequest',
]



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/declareParam/buildTaskModalCtr.js